import apiEndPoints from 'common/apiEndPoints';
import { performRequestFourth, performRequestSecond } from 'common/apiHandler';
import { getTenantDetails } from 'utils/utils';

export const sendTextMessage = ({
  contact_id,
  text_message_thread_sk,
  file_path,
  media_content_type,
  display_filename,
  size = null,
  data = {},
  timeEntryData = '',
  is_lead = false,
}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const url =
    `${apiEndPoints.sendTextMessage}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&contact_id=${contact_id}` +
    `${text_message_thread_sk ? `&text_message_thread_sk=${text_message_thread_sk}` : ''}` +
    `${file_path ? `&file_path=${file_path}` : ''}` +
    `${media_content_type ? `&media_content_type=${media_content_type}` : ''}` +
    `${display_filename ? `&display_filename=${display_filename}` : ''}` +
    `${size ? `&size=${size}` : ''} &is_lead=${is_lead}`;

  return performRequestSecond(apiEndPoints.methodType.POST, url, data, timeEntryData);
};

export const listMessageHistory = ({ contact_id, message_date = false, phoneNumber = '', limit = 50, offset = 0 }) => {
  const [tenantId, tenantSk] = getTenantDetails();

  // Build request body with offset-based pagination
  const requestBody = {
    contact_id: contact_id,
    phone_number: phoneNumber,
    limit: limit,
    offset: offset,
    ...(message_date && { message_date: message_date }),
  };

  return performRequestFourth(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.textMessageHistoryV2}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    requestBody,
    '',
    true,
    true
  );
};

export const messageMarkRead = ({ firm_user_id, thread_id, last_message_id, action = 'mark_read' }) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestFourth(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.updateTextStatusV2}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&firm_user_id=${firm_user_id}&thread_id=${thread_id}&last_message_id=${last_message_id}&action=${action}`,
    {},
    '',
    true,
    true
  );
};
